import 'features/Dashboard/assets/Dashboard.scss';
import React from 'react';
import { useUpdateRoleMutation } from 'services/roles/roles.api';
import RolePage from '../RoleManager';

const TAB_OPTIONS = ['Role Details', 'Permissions', 'Dashboard Edit', 'Dashboard View'];

export default function EditRole(): JSX.Element {
  type RoleSubmitPayload = {
    roleName: string;
    members: number[];
    permissions: string;
    layout: string;
    roleId?: string | number;
  };

  const [updateRoleTrigger] = useUpdateRoleMutation();
  const mutate = (payload: RoleSubmitPayload) => updateRoleTrigger(payload).unwrap();

  return <RolePage mode="edit" mutate={mutate} tabOptions={TAB_OPTIONS} />;
}
